import { DEFAULT_PORTFOLIO_SYMBOL } from "@app/_helpers";
import { OPTION_TYPE, SEARCH_SYMBOL_INSTRUMENT_TYPE } from "@app/_shared";
import { ExchangeId, OptionMode, OrderMode, SecurityType } from "../../../../../utProto/enums_pb";

export const LEG_INSTRUEMENT_TYPE = {
    [OPTION_TYPE.call]: 'Call Options',
    [OPTION_TYPE.put]: 'Put Options',
    [SEARCH_SYMBOL_INSTRUMENT_TYPE.FUTURE]: 'Futures',
}

export const LEG_INSTRUEMENT_TYPE_EQUITY = {
    [SEARCH_SYMBOL_INSTRUMENT_TYPE.EQUITY]: 'Equity'
}

export const SECURITY_TYPE = {
    [SecurityType.SECURITYTYPE_OPTION]: 'Options',
    [SecurityType.SECURITYTYPE_FUTURE]: 'Futures',
    [SecurityType.SECURITYTYPE_COMMON_STOCK]: 'Equity',
}


export const EXCHANGE_STRINGS_ENUM = {
    'NSEFO': ExchangeId.EXCHANGEID_NSEFO,
    'BSEFO': ExchangeId.EXCHANGEID_BSEFO,
    'NSECM': ExchangeId.EXCHANGEID_NSECM,
    'BSECM': ExchangeId.EXCHANGEID_BSECM,
}

export const MARGIN_CAL_DEFAULT_FORM_VALUES = {
    exchange: ExchangeId.EXCHANGEID_NSEFO.toString(),
    instrumentType: SEARCH_SYMBOL_INSTRUMENT_TYPE.FUTURE,
    symbol: DEFAULT_PORTFOLIO_SYMBOL,
    expiryType: null,
    lots: 1,
    strikePrice: null,
    orderMode: OrderMode.ORDERMODE_BUY.toString()
}

